/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import ic_platform_표준형_1 from "../image/표준형/ic_platform_1.png";
import ic_platform_표준형_10 from "../image/표준형/ic_platform_10.png";
import ic_platform_표준형_10_sel from "../image/표준형/ic_platform_10_sel.png";
import ic_platform_표준형_11 from "../image/표준형/ic_platform_11.png";
import ic_platform_표준형_11_sel from "../image/표준형/ic_platform_11_sel.png";
import ic_platform_표준형_12 from "../image/표준형/ic_platform_12.png";
import ic_platform_표준형_12_sel from "../image/표준형/ic_platform_12_sel.png";
import ic_platform_표준형_1_sel from "../image/표준형/ic_platform_1_sel.png";
import ic_platform_표준형_2 from "../image/표준형/ic_platform_2.png";
import ic_platform_표준형_2_sel from "../image/표준형/ic_platform_2_sel.png";
import ic_platform_표준형_3 from "../image/표준형/ic_platform_3.png";
import ic_platform_표준형_3_sel from "../image/표준형/ic_platform_3_sel.png";
import ic_platform_표준형_4 from "../image/표준형/ic_platform_4.png";
import ic_platform_표준형_4_sel from "../image/표준형/ic_platform_4_sel.png";
import ic_platform_표준형_5 from "../image/표준형/ic_platform_5.png";
import ic_platform_표준형_5_sel from "../image/표준형/ic_platform_5_sel.png";
import ic_platform_표준형_6 from "../image/표준형/ic_platform_6.png";
import ic_platform_표준형_6_sel from "../image/표준형/ic_platform_6_sel.png";
import ic_platform_표준형_7 from "../image/표준형/ic_platform_7.png";
import ic_platform_표준형_7_sel from "../image/표준형/ic_platform_7_sel.png";
import ic_platform_표준형_8 from "../image/표준형/ic_platform_8.png";
import ic_platform_표준형_8_sel from "../image/표준형/ic_platform_8_sel.png";
import ic_platform_표준형_9 from "../image/표준형/ic_platform_9.png";
import ic_platform_표준형_9_sel from "../image/표준형/ic_platform_9_sel.png";

import img_page1_1 from "../image/표준형/img_page1_1.png";
import img_page1_2 from "../image/표준형/img_page1_2.png";
import img_page1_3 from "../image/표준형/img_page1_3.png";
import img_page10_1 from "../image/표준형/img_page10_1.png";
import img_page10_2 from "../image/표준형/img_page10_2.png";
import img_page11_1 from "../image/표준형/img_page11_1.png";
import img_page11_2 from "../image/표준형/img_page11_2.png";
import img_page12_1 from "../image/표준형/img_page12_1.png";
import img_page12_2 from "../image/표준형/img_page12_2.png";
import img_page2 from "../image/표준형/img_page2.png";
import img_page3_1 from "../image/표준형/img_page3_1.png";
import img_page3_2 from "../image/표준형/img_page3_2.png";
import img_page5 from "../image/표준형/img_page5.png";
import img_page6 from "../image/표준형/img_page6.png";
import img_page7 from "../image/표준형/img_page7.png";
import img_page8_1 from "../image/표준형/img_page8_1.png";
import img_page8_2 from "../image/표준형/img_page8_2.png";
import img_page8_3 from "../image/표준형/img_page8_3.png";
import img_page8_4 from "../image/표준형/img_page8_4.png";
import img_page9_1 from "../image/표준형/img_page9_1.png";
import img_page9_2 from "../image/표준형/img_page9_2.png";
import img_page9_3 from "../image/표준형/img_page9_3.png";
import img_page9_4 from "../image/표준형/img_page9_4.png";
import img_page4 from "../image/표준형/img_page4.png";

const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 40px;
  @media (max-width: 800px) {
    padding-bottom: 29px;
  }
`;

const Main_Content4 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Main_Content5 = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Select_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 50px 15px 0px 15px;
    max-width: 650px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    max-width: 650px;
  }
`;

const Select_div3 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 0px 15px 0px 15px;
    max-width: 650px;
  }
`;

const Btn_Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  @media (max-width: 800px) {
    flex: 0;
  }
`;

const Main_Bar = styled.div`
  border-width: 2px 0px 0px 0px;
  border-color: ${theme.colors.bgGray};
  border-style: solid;
  width: 1200px;
  margin-bottom: 10px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Title_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
`;
const Image_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const Text_div2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  align-self: center;
  justify-content: center;
  text-align: left;
  margin-bottom: 50px;
  @media (max-width: 800px) {
    width: 80%;
  }
`;

const Info_Text = styled(Content_Text)`
  margin-top: 8px;
`;

const Image3 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "900px" : "800px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};
  border-radius: 8px;

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 60px;
  cursor: pointer;
`;

const Platform_FMS_표준형 = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [sel, set_Sel] = useState("01");

  useEffect(() => {
    // 사이즈 체크
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {windowSize.width > 1200 ? (
        <Main_div>
          <Select_div>
            <Main_Content4>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("01");
                  }}
                  src={
                    sel === "01"
                      ? ic_platform_표준형_1_sel
                      : ic_platform_표준형_1
                  }
                  alt={ic_platform_표준형_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "01"}
                  $lightGray
                  $small
                  $bold
                >
                  통합현황판
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("02");
                  }}
                  src={
                    sel === "02"
                      ? ic_platform_표준형_2_sel
                      : ic_platform_표준형_2
                  }
                  alt={ic_platform_표준형_2}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "02"}
                  $lightGray
                  $small
                  $bold
                >
                  파일관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("03");
                  }}
                  src={
                    sel === "03"
                      ? ic_platform_표준형_3_sel
                      : ic_platform_표준형_3
                  }
                  alt={ic_platform_표준형_3}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "03"}
                  $lightGray
                  $small
                  $bold
                >
                  일정관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("04");
                  }}
                  src={
                    sel === "04"
                      ? ic_platform_표준형_4_sel
                      : ic_platform_표준형_4
                  }
                  alt={ic_platform_표준형_4}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "04"}
                  $lightGray
                  $small
                  $bold
                >
                  예산현황
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("05");
                  }}
                  src={
                    sel === "05"
                      ? ic_platform_표준형_5_sel
                      : ic_platform_표준형_5
                  }
                  alt={ic_platform_표준형_5}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "05"}
                  $lightGray
                  $small
                  $bold
                >
                  운영관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("06");
                  }}
                  src={
                    sel === "06"
                      ? ic_platform_표준형_6_sel
                      : ic_platform_표준형_6
                  }
                  alt={ic_platform_표준형_6}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "06"}
                  $lightGray
                  $small
                  $bold
                >
                  결재관리
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("07");
                  }}
                  src={
                    sel === "07"
                      ? ic_platform_표준형_7_sel
                      : ic_platform_표준형_7
                  }
                  alt={ic_platform_표준형_7}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "07"}
                  $lightGray
                  $small
                  $bold
                >
                  건축물 정보
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("08");
                  }}
                  src={
                    sel === "08"
                      ? ic_platform_표준형_8_sel
                      : ic_platform_표준형_8
                  }
                  alt={ic_platform_표준형_8}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "08"}
                  $lightGray
                  $small
                  $bold
                >
                  시설관리
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("09");
                  }}
                  src={
                    sel === "09"
                      ? ic_platform_표준형_9_sel
                      : ic_platform_표준형_9
                  }
                  alt={ic_platform_표준형_9}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "09"}
                  $lightGray
                  $small
                  $bold
                >
                  업무일지
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("10");
                  }}
                  src={
                    sel === "10"
                      ? ic_platform_표준형_10_sel
                      : ic_platform_표준형_10
                  }
                  alt={ic_platform_표준형_10}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "10"}
                  $lightGray
                  $small
                  $bold
                >
                  자재관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("11");
                  }}
                  src={
                    sel === "11"
                      ? ic_platform_표준형_11_sel
                      : ic_platform_표준형_11
                  }
                  alt={ic_platform_표준형_11}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "11"}
                  $lightGray
                  $small
                  $bold
                >
                  에너지관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("12");
                  }}
                  src={
                    sel === "12"
                      ? ic_platform_표준형_12_sel
                      : ic_platform_표준형_12
                  }
                  alt={ic_platform_표준형_12}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "12"}
                  $lightGray
                  $small
                  $bold
                >
                  직원관리
                </Content_Text>
              </Btn_Div>
            </Main_Content4>
          </Select_div>
        </Main_div>
      ) : windowSize.width > 800 ? (
        <>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={
                      sel === "01"
                        ? ic_platform_표준형_1_sel
                        : ic_platform_표준형_1
                    }
                    alt={ic_platform_표준형_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "01"}
                    $lightGray
                    $small
                    $bold
                  >
                    통합현황판
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={
                      sel === "02"
                        ? ic_platform_표준형_2_sel
                        : ic_platform_표준형_2
                    }
                    alt={ic_platform_표준형_2}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "02"}
                    $lightGray
                    $small
                    $bold
                  >
                    파일관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={
                      sel === "03"
                        ? ic_platform_표준형_3_sel
                        : ic_platform_표준형_3
                    }
                    alt={ic_platform_표준형_3}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "03"}
                    $lightGray
                    $small
                    $bold
                  >
                    일정관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={
                      sel === "04"
                        ? ic_platform_표준형_4_sel
                        : ic_platform_표준형_4
                    }
                    alt={ic_platform_표준형_4}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "04"}
                    $lightGray
                    $small
                    $bold
                  >
                    예산현황
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={
                      sel === "05"
                        ? ic_platform_표준형_5_sel
                        : ic_platform_표준형_5
                    }
                    alt={ic_platform_표준형_5}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "05"}
                    $lightGray
                    $small
                    $bold
                  >
                    운영관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={
                      sel === "06"
                        ? ic_platform_표준형_6_sel
                        : ic_platform_표준형_6
                    }
                    alt={ic_platform_표준형_6}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "06"}
                    $lightGray
                    $small
                    $bold
                  >
                    결재관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div3>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={
                      sel === "07"
                        ? ic_platform_표준형_7_sel
                        : ic_platform_표준형_7
                    }
                    alt={ic_platform_표준형_7}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "07"}
                    $lightGray
                    $small
                    $bold
                  >
                    건축물 정보
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={
                      sel === "08"
                        ? ic_platform_표준형_8_sel
                        : ic_platform_표준형_8
                    }
                    alt={ic_platform_표준형_8}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "08"}
                    $lightGray
                    $small
                    $bold
                  >
                    시설관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={
                      sel === "09"
                        ? ic_platform_표준형_9_sel
                        : ic_platform_표준형_9
                    }
                    alt={ic_platform_표준형_9}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "09"}
                    $lightGray
                    $small
                    $bold
                  >
                    업무일지
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={
                      sel === "10"
                        ? ic_platform_표준형_10_sel
                        : ic_platform_표준형_10
                    }
                    alt={ic_platform_표준형_10}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "10"}
                    $lightGray
                    $small
                    $bold
                  >
                    자재관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("11");
                    }}
                    src={
                      sel === "11"
                        ? ic_platform_표준형_11_sel
                        : ic_platform_표준형_11
                    }
                    alt={ic_platform_표준형_11}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "11"}
                    $lightGray
                    $small
                    $bold
                  >
                    에너지관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("12");
                    }}
                    src={
                      sel === "12"
                        ? ic_platform_표준형_12_sel
                        : ic_platform_표준형_12
                    }
                    alt={ic_platform_표준형_12}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "12"}
                    $lightGray
                    $small
                    $bold
                  >
                    직원관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div3>
          </Main_div>
        </>
      ) : (
        <>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={
                      sel === "01"
                        ? ic_platform_표준형_1_sel
                        : ic_platform_표준형_1
                    }
                    alt={ic_platform_표준형_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "01"}
                    $lightGray
                    $small
                    $bold
                  >
                    통합현황판
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={
                      sel === "02"
                        ? ic_platform_표준형_2_sel
                        : ic_platform_표준형_2
                    }
                    alt={ic_platform_표준형_2}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "02"}
                    $lightGray
                    $small
                    $bold
                  >
                    파일관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={
                      sel === "03"
                        ? ic_platform_표준형_3_sel
                        : ic_platform_표준형_3
                    }
                    alt={ic_platform_표준형_3}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "03"}
                    $lightGray
                    $small
                    $bold
                  >
                    일정관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={
                      sel === "04"
                        ? ic_platform_표준형_4_sel
                        : ic_platform_표준형_4
                    }
                    alt={ic_platform_표준형_4}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "04"}
                    $lightGray
                    $small
                    $bold
                  >
                    예산현황
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={
                      sel === "05"
                        ? ic_platform_표준형_5_sel
                        : ic_platform_표준형_5
                    }
                    alt={ic_platform_표준형_5}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "05"}
                    $lightGray
                    $small
                    $bold
                  >
                    운영관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={
                      sel === "06"
                        ? ic_platform_표준형_6_sel
                        : ic_platform_표준형_6
                    }
                    alt={ic_platform_표준형_6}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "06"}
                    $lightGray
                    $small
                    $bold
                  >
                    결재관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={
                      sel === "07"
                        ? ic_platform_표준형_7_sel
                        : ic_platform_표준형_7
                    }
                    alt={ic_platform_표준형_7}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "07"}
                    $lightGray
                    $small
                    $bold
                  >
                    건축물 정보
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={
                      sel === "08"
                        ? ic_platform_표준형_8_sel
                        : ic_platform_표준형_8
                    }
                    alt={ic_platform_표준형_8}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "08"}
                    $lightGray
                    $small
                    $bold
                  >
                    시설관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={
                      sel === "09"
                        ? ic_platform_표준형_9_sel
                        : ic_platform_표준형_9
                    }
                    alt={ic_platform_표준형_9}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "09"}
                    $lightGray
                    $small
                    $bold
                  >
                    업무일지
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={
                      sel === "10"
                        ? ic_platform_표준형_10_sel
                        : ic_platform_표준형_10
                    }
                    alt={ic_platform_표준형_10}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "10"}
                    $lightGray
                    $small
                    $bold
                  >
                    자재관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div>
              <Main_Content5 style={{ justifyContent: "space-between" }}>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("11");
                    }}
                    src={
                      sel === "11"
                        ? ic_platform_표준형_11_sel
                        : ic_platform_표준형_11
                    }
                    alt={ic_platform_표준형_11}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "11"}
                    $lightGray
                    $small
                    $bold
                  >
                    에너지관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("12");
                    }}
                    src={
                      sel === "12"
                        ? ic_platform_표준형_12_sel
                        : ic_platform_표준형_12
                    }
                    alt={ic_platform_표준형_12}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "12"}
                    $lightGray
                    $small
                    $bold
                  >
                    직원관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content5>
            </Select_div>
          </Main_div>
        </>
      )}
      <Main_div>
        <Main_Bar></Main_Bar>
      </Main_div>
      <Title_div>
        <Content_Text $bold $blue2>
          {sel}
        </Content_Text>
      </Title_div>
      <Title_div style={{ marginBottom: 30 }}>
        <Content_Text $xlarge $xbold>
          {sel === "01"
            ? "통합현황판"
            : sel === "02"
            ? "파일관리"
            : sel === "03"
            ? "일정관리"
            : sel === "04"
            ? "예산현황"
            : sel === "05"
            ? "운영관리"
            : sel === "06"
            ? "결재관리"
            : sel === "07"
            ? "건축물 정보"
            : sel === "08"
            ? "시설관리"
            : sel === "09"
            ? "업무일지"
            : sel === "10"
            ? "자재관리"
            : sel === "11"
            ? "에너지관리"
            : "직원관리"}
        </Content_Text>
      </Title_div>
      {sel === "01" ? (
        <>
          <Image_div2>
            <Image3 src={img_page1_1} alt={img_page1_1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              상세기능
            </Content_Text>
            <Info_Text $gray>
              1) 주간 일정 및 세부 일정에 대해 점검하고 체크할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 점검해야될 시설에 대해 주기를 확인하고 점검할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              3) 결재 서류에 대해 상태를 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              4) 부족한 재고에 대해 알림을 받고, 조회할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>5) 대기중인 민원을 조회할 수 있습니다.</Info_Text>
            <Info_Text $gray>
              6) [집행,미집행] 예산에 대해 체크하고 관리할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              7) 에너지 사용량에 대해 조회하고 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page1_2} alt={img_page1_2} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page1_3} alt={img_page1_3} />
          </Image_div2>
        </>
      ) : sel === "02" ? (
        <>
          <Image_div2>
            <Image3 src={img_page2} alt={img_page2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수
              있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "03" ? (
        <>
          <Image_div2>
            <Image3 src={img_page3_1} alt={img_page3_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page3_2} alt={img_page3_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 일정을 분류하고 등록 및 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "04" ? (
        <>
          <Image_div2>
            <Image3 src={img_page4} alt={img_page4} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 한 해의 예산을 계획하고 이에 맞춰 집행내역을 작성할 수
              있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "05" ? (
        <>
          <Image_div2>
            <Image3 src={img_page5} alt={img_page5} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 장비 분류에 따른 운영계획을 작성할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "06" ? (
        <>
          <Image_div2>
            <Image3 src={img_page6} alt={img_page6} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 결재가 필요한 업무 일지들을 확인할 수 있으며 결재 요청 및
              승인을 진행할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "07" ? (
        <>
          <Image_div2>
            <Image3 src={img_page7} alt={img_page7} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 건축물 정보를 입력하고 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "08" ? (
        <>
          <Image_div2>
            <Image3 src={img_page8_1} alt={img_page8_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page8_2} alt={img_page8_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 시설을 등록할 수 있으며, 점검에 필요한 QR코드를 생성할 수
              있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 등록된 민원을 확인할 수 있으며, 해결이 필요한 민원을 처리할 수
              있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page8_3} alt={img_page8_3} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page8_4} alt={img_page8_4} />
          </Image_div2>
        </>
      ) : sel === "09" ? (
        <>
          <Image_div2>
            <Image3 src={img_page9_1} alt={img_page9_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page9_2} alt={img_page9_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 등록된 업무일지에 대해서 PC 및 모바일에서 점검할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>2) 다음 점검일을 확인할 수 있습니다. </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page9_3} alt={img_page9_3} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page9_4} alt={img_page9_4} />
          </Image_div2>
        </>
      ) : sel === "10" ? (
        <>
          <Image_div2>
            <Image3 src={img_page10_1} alt={img_page10_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page10_2} alt={img_page10_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 자재를 등록하고 입·출고 관리 및 창고관리를 할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 자재들의 상태 내역을 확인할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "11" ? (
        <>
          <Image_div2>
            <Image3 src={img_page11_1} alt={img_page11_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세기능
            </Info_Text>
            <Info_Text $gray>
              1) 에너지 현황을 모니터링하며 관리할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 에너지값들을 등록하여 4개년의 정보를 비교 분석할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page11_2} alt={img_page11_2} />
          </Image_div2>
        </>
      ) : (
        <>
          <Image_div2>
            <Image3 src={img_page12_1} alt={img_page12_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page12_2} alt={img_page12_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상세 기능
            </Info_Text>
            <Info_Text $gray>
              1) 직원들을 등록하고 상태를 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      )}
    </>
  );
};

export default Platform_FMS_표준형;
